// extracted by mini-css-extract-plugin
module.exports = {"footerSitemapLinks":"Footer_footerSitemapLinks__v1ien","rgText":"Footer_rgText__BLNB0"};